import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Panel, theme } from '@xometry/xometry_loft';

export const DefaultShippingAddressIndicator = styled.div`
  font-weight: ${theme.fontWeights.semibold};
  margin-bottom: ${theme.space[3]};
  display: inline-block;
`;

export const shippingAddress = css`
  flex-wrap: wrap;
  display: flex;
  align-items: flex-start;
  margin-top: ${theme.space[4]};
  margin-bottom: ${theme.space[9]};
  gap: ${theme.space[6]};
  padding: ${theme.space[5]};
  @media (min-width: 1024px) {
    min-width: 752px;
  }
`;

export const shippingAddressText = css`
  display: flex;
  flex-direction: column;
  min-width: 0;
  max-width: 100%;
  overflow-wrap: break-word;
  word-break: break-word;
`;

export const shippingAddressEdit = css`
  float: right;
  cursor: pointer;
  font-size: ${theme.fontSizes[1]};
  line-height: ${theme.lineHeights[2]};
`;

export const addShippingImage = css`
  width: 200px;
`;

export const AddShippingContainer = styled.div`
  cursor: 'pointer';
  width: 100%;
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px dashed ${theme.colors.blues[25]};
  color: ${theme.colors.darkBlues[90]};
  font-size: ${theme.fontSizes[2]};
  line-height: ${theme.lineHeights[3]};
  font-weight: ${theme.fontWeights.semibold};
`;

export const ShippingAddressPanel = styled(Panel)`
  min-height: 258px;
  min-width: 0;
  line-height: ${theme.space[6]};
  font-size: ${theme.space[4]};
  color: #253842;
  padding: ${theme.space[6]};
  flex-basis: calc(50% - ${theme.space[3]});
  box-sizing: border-box;
  overflow-wrap: break-word;
  word-break: break-word;
`;
